import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const RidePassengersCsvListWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-passengers-csv-wrapper",
  },
)`
  .passenger-name {
    margin-inline-end: 4px;
    cursor: pointer;
  }
`;

export const RidePassengersTooltipContentWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "tooltip-content-container",
  },
)`
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 20px;

  .tooltip-content-item {
    padding-inline: 2px;

    &.full-name {
      color: ${rydeColors.lightBlue};
      cursor: pointer;
    }
  }

  .divider {
    background: ${rydeColors.white};
    margin-inline: 4px;
  }
`;
